import { Injectable, EventEmitter, Inject } from '@angular/core';
import { AuthService } from '../../auth.service';
import { VideoChatMessage } from '../../../model/video-chat/video-chat-message'; 
import { NotificationToastService } from '../../notification-toast.service';
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class MessageServerService {
  
  public openReceived: EventEmitter<boolean>;
  public callerReceived: EventEmitter<string>;
  public physicianReceived: EventEmitter<string>;
  public videoChatReceived: EventEmitter<string>;
  public videoChatNegotiationMessageReceived: EventEmitter<any>;
  public connectionExists: boolean;
  public connectoinId: string;
  private proxy: any;
  private proxyName = 'serverMessageHub';
  private connection: any;

  constructor(@Inject('BASE_URL') private baseUrl: string,
              private authService: AuthService,
              private notificationToastService: NotificationToastService) {
    this.notificationToastService.pushNotificationRequestPermission();
  }

  public createHubProxyAndStarConnection() {

    this.physicianReceived = new EventEmitter<string>();
    this.callerReceived = new EventEmitter<string>();
    this.videoChatReceived =  new EventEmitter<string>();
    this.openReceived = new EventEmitter<boolean>();
    this.videoChatNegotiationMessageReceived = new EventEmitter<any>();

    this.connectionExists = false;
    // create hub connection
    this.connection = $.hubConnection(this.baseUrl);
    // create new proxy as name already given in top
    this.proxy = this.connection.createHubProxy(this.proxyName);
    // register on server events
    this.registerOnServerEvents();
    // call the connecion start method to start the connection to send and receive events.
    this.startConnection();
  }

  public isConnected(): boolean {
    return this.connectionExists;
  }

  public sendMessage(message: string) {
    if (this.connectionExists) {
      this.proxy.invoke('SendMessage', message);
    }
  }

  public joinPhysicianGroup() {
    if (this.connectionExists) {
      this.proxy.invoke('JoinGroup', 'PHYSICIAN');
    }
  }

  public joinGroups() {

    if (this.connectionExists) {
      this.proxy.invoke('JoinGroup', 'ALL');

      if ( this.authService.receiveMedicalAppointmentWaitNotification() ) {
        this.proxy.invoke('JoinGroup', 'PUSHNOTIFICACIONTURNOESPERA');
      }
    }
  }

  public joinCallerGroup() {
    if (this.connectionExists) {
      this.proxy.invoke('JoinGroup', 'CALLER');
    }
  }

  private startConnection(): void {
    this.connection.start().done((data: any) => {
      this.connectionExists = true;
      this.connectoinId = data.id;
      this.openReceived.emit(true);
      this.joinGroups();
    }).fail((error: any) => {
      this.openReceived.emit(false);
    });
  }

  private registerOnServerEvents(): void {

    this.proxy.on('receiveMessage', ( message, group ) => {
      if ( group === 'PHYSICIAN' ) {
        this.physicianReceived.emit(message);
      } else if ( group === 'CALLER' ) {
        this.callerReceived.emit(message);
      } else {
        this.notificationToastService.sendPushNotification(message);
      }
    });

    this.proxy.on('receiveVideoChatNegotiationMessage', ( message ) => {
      this.videoChatNegotiationMessageReceived.emit(message);
    });
  }
}
